const AUDIT_LOG_KINDS: Record<string, string> = {
  searchable_log: 'Searchable log',
  archived_log: 'Archived log',
}

export const getAuditLogKindLabel = (kind?: string | null, fallback = ''): string => (kind && AUDIT_LOG_KINDS[kind]) || kind || fallback
